export const initialState = {
  loading: {
    state: false,
    text: "",
  },
  booths: {
    list: [],
    boothId: "",
    youtubeApiKey: "",
    youtubeChannelId: "",
  },
  opuses: {
    list: [],
  },
  users: {
    isSignedIn: false, // サインインしているか？& 購入,質問+便乗,テスト個展(月1回3日間),通知受信ができる
    isCntracted: false, // 月額契約後trueへ。本番個展登録,ライブ配信ができる
    uid: "",
    username: "",
    avatar: "",
  },
};
